import { render, staticRenderFns } from "./EmptyStateVS.vue?vue&type=template&id=2ef06a1b&scoped=true"
import script from "./EmptyStateVS.vue?vue&type=script&lang=js"
export * from "./EmptyStateVS.vue?vue&type=script&lang=js"
import style0 from "./EmptyStateVS.vue?vue&type=style&index=0&id=2ef06a1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef06a1b",
  null
  
)

export default component.exports